<tui-root>
    <div class="storenContainer mx-auto">
        <section class="bg-white mb-5" *ngIf="currentSurveyStep === 6">
            <div class="row mt-5">
                <div class="mx-auto">
                    <div class="text-center">
                        <div class="my-4 flex justify-center items-center pointer-events-none">
                            <img src="../assets/Check.png" alt="" class="w-[92px] h-[92px]">
                        </div>
                        <div class="my-4"id="programComplete">
                            <p class="text-[36px] font-bold leading-[37px]">Thank you for your submission!</p>
                            <div class="flex flex-col gap-2 mt-4 text-neutral-500">
                                <p class="text-[16px] leading-[24px]">Your participation in the Storen
                                    Satisfaction
                                    Program is now complete! Your selected reward will be shipped to the address
                                    provided during sign-up. You’ll receive an email confirmation once your
                                    reward
                                    has shipped.*</p>
                                <p class="text-[16px] leading-[24px] mt-4">Limit one (1) Storen hat or beanie per
                                    eligible participant.</p>
                                <p class="text-[16px] leading-[24px] underline cursor-pointer"><a (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-terms-and-conditions.pdf', '2025_SSP_Program_Sheet_Page_1 2.pdf')">View full program terms
                                        and conditions.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="m-3">
                        <button (click)="returnToMainDashboard()" tuiButton appearance="primary-grayscale" size="m"
                            class="rounded-0 text-white w-100 dark-btn-hover">
                            Return to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</tui-root>